import { gql } from "@apollo/client"

export const CREATE_CONSENT_RECEIPT = gql`
  mutation CreateConsentReceipt($input: CreateConsentReceiptInput!) {
    createConsentReceipt(input: $input) {
      receipt
      status
    }
  }
`
